/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-param-reassign */
import {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { DropdownSelectField } from '@jutro/components/internal';
import { useTranslator } from '@jutro/locale';
import styles from '../../../SpaAndWellCommonStyles.module.scss'
import metadata from './TanningEquipment.metadata.json5';

function TanningEquipment(props) {

    const {
        data: tanningEquipVM,
        updateWizardData,
        submissionVM,
        tanningEquipPath,
        pathUpdated
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator()

    const calculateTotalNumOfUnits = useCallback(() => {

        const sum = tanningEquipVM.value.reduce((acc, item) => acc + +(item.uniFie ?? 0), 0);

        _.set(submissionVM, `${pathUpdated}.totNumOfAllTypFie`, sum)

    }, [pathUpdated, submissionVM, tanningEquipVM.value])


    const addTanEquip = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            tanningEquipVM.value = tanningEquipVM.value || []

            const { _xCenter, _dtoName } = tanningEquipVM;

            const TanEquipObjVM = viewModelService.create(
                { uniFie: 1 },
                _xCenter,
                _dtoName
            );

            TanEquipObjVM.isValidationReq = true;

            tanningEquipVM.pushElement(
                TanEquipObjVM
            );

            calculateTotalNumOfUnits()
            updateWizardData(submissionVM);
        },
        [tanningEquipVM, viewModelService, calculateTotalNumOfUnits, updateWizardData, submissionVM]
    );


    const handleValueChange = useCallback(
        (value, path) => {

            if (path === 'uniFie') {
                calculateTotalNumOfUnits()
            }

            updateWizardData(submissionVM);
        },
        [calculateTotalNumOfUnits, submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            tanningEquipVM.value.splice(index, 1);

            calculateTotalNumOfUnits()
            _.set(submissionVM.value, tanningEquipPath, tanningEquipVM.value);
            updateWizardData(submissionVM);
        }, [tanningEquipVM.value, calculateTotalNumOfUnits, submissionVM, tanningEquipPath, updateWizardData]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'equFie') {
                const value = item.equFie ? item.equFie : '';

                const availableValues = tanningEquipVM.length > 0 && tanningEquipVM.children[index].equFie
                    ? tanningEquipVM.children[index].equFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="string"
                        onValueChange={(val, changedPath) => {
                            item.equFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        availableValues={availableValues}
                    />
                );
            }

            if (path === 'uniFie') {
                const value = item.uniFie ? item.uniFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.uniFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'typOfTimFie') {
                const value = item.typOfTimFie ? item.typOfTimFie : '';

                const availableValues = tanningEquipVM.length > 0 && tanningEquipVM.children[index].typOfTimFie
                    ? tanningEquipVM.children[index].typOfTimFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="string"
                        onValueChange={(val, changedPath) => {
                            item.typOfTimFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        availableValues={availableValues}
                    />
                );
            }

        }, [handleValueChange, tanningEquipVM.children, tanningEquipVM.length, translator])

    const removeTanningEqupTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`TanningEquipTable`]: {
            data: tanningEquipVM.value,
        }

    }), [tanningEquipVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addTanEquip,
            getTableCell,
            removeTanningEqupTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.componentContent,
            tanningEquipVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [tanningEquipVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={tanningEquipVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TanningEquipment.propTypes = wizardProps;
export default withRouter(TanningEquipment);
